import { ActionFactory } from '@/components/utils';

export const Actions = ActionFactory({
  delete: false,
  edit: false,
  editDispute: true,
  editNote: true,
  editStatus: false,
  list: false,
  refresh: false,
  resumeChecks: false,
  sendAdverse: true,
  sendPreAdverse: true,
});
